import { motion } from 'framer-motion';
import BeforeAfter from './BeforeAfter';
import type { Shift } from '../data/shifts';

interface Props {
  shift: Shift;
  index: number;
}

export default function ShiftCard({ shift, index }: Props) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 12 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.4, delay: index * 0.04 }}
      className="rounded-2xl border hairline bg-elevated/60 p-7 hover:border-accent/40 transition-colors"
    >
      <p className="font-mono text-[11px] text-accent tracking-widest mb-3">
        SHIFT {String(index + 1).padStart(2, '0')}
      </p>
      <h3 className="font-display text-2xl md:text-3xl tracking-tight2 mb-5">
        {shift.title}
      </h3>
      <BeforeAfter before={shift.before} after={shift.after} />
      <div className="mt-6 grid grid-cols-2 gap-4 text-sm">
        <div>
          <div className="text-good font-mono text-[11px] mb-1">BENEFIT</div>
          <p className="text-ink-dim leading-relaxed">{shift.benefit}</p>
        </div>
        <div>
          <div className="text-risk font-mono text-[11px] mb-1">RISK</div>
          <p className="text-ink-dim leading-relaxed">{shift.risk}</p>
        </div>
      </div>
    </motion.article>
  );
}
